import m from "mithril"
import { state, loadData, getFilteredProjects, getProjectById } from "../state/store.js"
import Header from "../components/Header.js"
import MobileNav from "../components/MobileNav.js"
import Hero from "../components/Hero.js"
import Filters from "../components/Filters.js"
import ProjectGrid from "../components/ProjectGrid.js"
import EmptyState from "../components/EmptyState.js"
import Footer from "../components/Footer.js"
import ProjectModal from "../components/ProjectModal.js"
import { FluidBackground } from "../components/FluidBackground.js"

export const Home = {
  oninit: function () {
    if (state.projects.length === 0) {
      loadData()
    }
  },
  view: function (vnode) {
    var filtered = getFilteredProjects()
    var projectId = vnode.attrs.id
    var modalProject = projectId ? getProjectById(projectId) : null

    return [
      m(FluidBackground),
      m(Header),
      m(MobileNav),
      m(Hero),
      m(Filters, { count: filtered.length }),
      filtered.length > 0
        ? m(ProjectGrid, { projects: filtered })
        : (!state.loading ? m(EmptyState) : null),
      m(Footer),
      m(ProjectModal, { project: modalProject }),
    ]
  },
}
